import { Component, Input, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { CsvexportService } from 'src/app/services/tools/csv/csvexport.service';

@Component({
  selector: 'app-export-button',
  templateUrl: './export-button.component.html',
  styleUrls: ['./export-button.component.scss']
})
export class ExportButtonComponent implements OnInit {
   // URL for the CSV file.
  public csvUrl!: SafeResourceUrl;

  @Input() 
  data!: any[];

  constructor( private csvExporter: CsvexportService) { }

  ngOnInit(): void {
  }

  
  /**
   * Get the current data as CSV
   */
   public prepareCSV(){
    console.log(this.data);
    this.csvUrl = this.csvExporter.prepareCSV( this.data );
  }

}
